export type { DeprecationMain, DeprecationInfo, DeprecationMetadata } from './deprecation.main.runtime';
export { DeprecationAspect, DeprecationAspect as default } from './deprecation.aspect';
